import { Page } from '@vitvio/navigation';
import { GenericErrorPage, PrimaryButton } from '@vitvio/shared-components';
import { Text, Button, Flex } from '@vitvio/design-system';

export function PageNotFound() {
  return (
    <Page title="Page Not Found">
      <GenericErrorPage errorHeadingText="Page not found">
        <Text>Sorry, the page you're looking for doesn’t exist.</Text>
        <Text>Try double-checking your link or head back to homepage.</Text>
        <Flex gap={2} mt={6} alignItems={'center'} flexDirection={'column'}>
          <PrimaryButton text="Back to homepage" onClickFn={() => (window.location.href = '/')} />
          <Button>Report the issue</Button>
        </Flex>
      </GenericErrorPage>
    </Page>
  );
}
